/**
 * Placeholder page for a 401
 */
import React from 'react';

function UnauthorizedPage() {
  return <h1>Sorry! You don&apos;t have permissions to view this page.</h1>;
}

export default UnauthorizedPage;
